import { render } from "./Validation_Licences.vue?vue&type=template&id=85bc02d8&scoped=true"
import script from "./Validation_Licences.vue?vue&type=script&lang=js"
export * from "./Validation_Licences.vue?vue&type=script&lang=js"

import "./Validation_Licences.vue?vue&type=style&index=0&id=85bc02d8&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85bc02d8"]])

export default __exports__